import { render, staticRenderFns } from "./MchInfoArch.vue?vue&type=template&id=d92cf712&scoped=true"
import script from "./MchInfoArch.vue?vue&type=script&lang=js"
export * from "./MchInfoArch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d92cf712",
  null
  
)

export default component.exports